import { render, staticRenderFns } from "./ChatConversationItem.vue?vue&type=template&id=dc264a96&scoped=true"
import script from "./ChatConversationItem.vue?vue&type=script&lang=js"
export * from "./ChatConversationItem.vue?vue&type=script&lang=js"
import style0 from "./ChatConversationItem.vue?vue&type=style&index=0&id=dc264a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc264a96",
  null
  
)

export default component.exports